import { FC, Fragment } from 'react'
import { ApproveRisk } from './ApproveRisk'
import { Box, makeStyles } from '@material-ui/core'
import { createStyles } from '@material-ui/core/styles'
import { RejectRisk } from './RejectRisk'
import { useSubmitViolationItemDecision } from 'hooks'
import { DoNothing } from './DoNothing'

const useStyles = makeStyles(
    createStyles({
        root: {
            display: 'flex',
        },
        button: {
            margin: '0 4px',
            '& button': {
                minWidth: 'auto',
                maxWidth: '40px',
                padding: '3.25px 3px 3.25px 16px',
            },
        },
    }),
)

export const ViolatingItemDecision: FC<{ item: any }> = (props) => {
    const classes = useStyles()
    const { item } = props

    const [
        submitRiskDecision,
        { isLoading: isSubmitting },
    ] = useSubmitViolationItemDecision(
        'Requests',
        item.businessRequestId,
        item.id,
    )

    return (
        <Fragment>
            {item.decisions && (
                <Box className={classes.root}>
                    {item.decisions.map((d: any) => (
                        <Fragment key={d.decisionId}>
                            {d.decisionAction === 'Continue' ? (
                                <Box className={classes.button}>
                                    <ApproveRisk
                                        currentApprovalStepId={
                                            item.currentApprovalStepId
                                        }
                                        onSubmit={(value) => {
                                            const approveReq = {
                                                ...value,
                                                stepId:
                                                    item.currentApprovalStepId,
                                                decisionId: d.decisionId,
                                            }
                                            return submitRiskDecision(
                                                approveReq,
                                            )
                                        }}
                                        decisionFriendlyName={
                                            d.decisionFriendlyName
                                        }
                                        isLoading={isSubmitting}
                                    />
                                </Box>
                            ) : d.decisionAction === 'DoNothing' ? (
                                <Box className={classes.button}>
                                    <DoNothing d={d} item={item} />
                                </Box>
                            ) : (
                                <Box className={classes.button}>
                                    <RejectRisk d={d} item={item} />
                                </Box>
                            )}
                        </Fragment>
                    ))}
                </Box>
            )}
        </Fragment>
    )
}
